import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5ea56a99"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "legend__home" }, [
  /*#__PURE__*/_createElementVNode("h2", null, "SO, YOU WANT TO TRAVEL TO"),
  /*#__PURE__*/_createElementVNode("h1", null, "SPACE"),
  /*#__PURE__*/_createElementVNode("p", null, " Let’s face it; if you want to go to space, you might as well genuinely go to outer space and not hover kind of on the edge of it. Well sit back, and relax because we’ll give you a truly out of this world experience! ")
], -1))
const _hoisted_3 = { class: "btn__home" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("main", null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", {
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.exploreDestination && _ctx.exploreDestination(...args))),
          class: "button"
        }, "Explore")
      ])
    ])
  ]))
}